<div class="columns small-12 medium-8">
  <p
    [innerHTML]="'internet.settings.password.description' | translate: true"
    data-cy="internetUpdatePasswordDescription"
  ></p>
  <div class="rs-flex-row">
    <div class="rs-flex-columns">
      <p>{{ 'internet.settings.password.login' | translate }}</p>
    </div>
    <div class="rs-flex-columns rs-flex-grow">
      <p class="rs-font-pxB" data-cy="internetUpdatePasswordIdentifier">
        {{ loginId }}@SKYNET/PROXIMUS
      </p>
    </div>
  </div>

  <!-- New password section -->
  <div class="rs-form-item">
    <input
      [type]="hidePassword ? 'password' : 'text'"
      id="ac-password1"
      [(ngModel)]="password"
      #newPasswordInput="ngModel"
      (ngModelChange)="validatePassword()"
      maxlength="8"
      aria-describedby="ac-helper-pwd1"
      [ngClass]="{ 'rs-filled': !isNewPasswordEmpty() }"
      data-cy="internetUpdatePassword1"
    /><span
      aria-label="See or hide password"
      role="button"
      tabindex="0"
      class="jsrs-togglePassword rs-see-pwd"
      [ngClass]="{ 'rs-active': !hidePassword }"
      (click)="togglePasswordVisibility()"
    ></span
    ><label class="rs-form-label" for="ac-password1">{{
      'internet.settings.password.newPassword' | translate
    }}</label>
    <div class="rs-form-helper" id="ac-helper-pwd1">
      <ul>
        <li
          [ngClass]="{
            '': newPasswordInput.touched || newPasswordInput.dirty,
            'rs-form-success':
              (newPasswordInput.touched || newPasswordInput.dirty) &&
              isPasswordValid &&
              !isNewPasswordEmpty(),
            'rs-form-error':
              (newPasswordInput.touched || newPasswordInput.dirty) &&
              !isPasswordValid &&
              !isNewPasswordEmpty()
          }"
        >
          {{ 'internet.settings.password.length.error' | translate }}
        </li>
      </ul>
    </div>
  </div>

  <!-- Confirm password section -->
  <div class="rs-form-item">
    <input
      [type]="hideConfirmPassword ? 'password' : 'text'"
      id="ac-password2"
      [(ngModel)]="confirmPassword"
      #confirmPasswordInput="ngModel"
      (ngModelChange)="validateConfirmPassword()"
      maxlength="8"
      aria-describedby="ac-password2"
      [ngClass]="{ 'rs-filled': !isConfirmPasswordEmpty() }"
      data-cy="internetUpdatePassword2"
    /><span
      aria-label="See or hide password"
      role="button"
      tabindex="0"
      class="jsrs-togglePassword rs-see-pwd"
      [ngClass]="{ 'rs-active': !hideConfirmPassword }"
      (click)="toggleConfirmPasswordVisibility()"
    ></span
    ><label for="ac-password2" class="rs-form-label">{{
      'internet.settings.password.repeatPassword' | translate
    }}</label
    ><span
      id="ac-error2"
      class="error"
      *ngIf="
        !isConfirmPasswordValid && (confirmPasswordInput.touched || confirmPasswordInput.dirty)
      "
      >{{ 'internet.settings.password.match.error' | translate }}</span
    >
  </div>

  <!-- Submit button -->
  <button
    type="submit"
    class="rs-btn"
    [disabled]="!validate()"
    [ngClass]="{ 'rs-btn-disabled': !validate() }"
    (click)="updatePassword()"
    data-tms-event="button-click"
    attr.data-tms-button-zone="{{ 'internet.settings.password.title' | translate }}"
    data-tms-button-name="confirm"
    data-cy="internetUpdateSubmitButton"
  >
    {{ 'internet.settings.password.confirm' | translate }}
  </button>

  <!-- Confirmation message after you call service -->
  <px-alert [alertKey]="'updateInternetPasswordAlert'" data-cy="internetUpdateAlert"></px-alert>
</div>
